import { originalRequest, baseService, newBaseService } from '../request'
import ResponseType from '../models/ResponseTypes'

export type TPayParams = {
  balanceCode: string
  [key: string]: any
}

export async function pay(params: TPayParams) {
  let isStoreGray

  try {
    // 门店是否灰度
    const data = await originalRequest<
      TPayParams,
      ResponseType<{ flag: boolean }>
    >(`${newBaseService}/public/v2/module/maintenance/gray/balance`, {
      balanceCode: params.balanceCode,
      // NOTE: 这个CODE是跟后端商定写死的
      code: 'group_v',
    })
    isStoreGray = !!data.flag
  } catch (err) {
    isStoreGray = false
  }

  return originalRequest<
    TPayParams,
    ResponseType<{ prePayId: string; url: string }>
  >(
    `${isStoreGray ? newBaseService : baseService}/public/v1/repair/order/pay`,
    params
  )
}
